import React, { useState } from "react";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import "./BillingNotification.css";

const icons = {
  info: <InfoIcon className="icon info" />,
  warning: <WarningIcon className="icon warning" />,
  danger: <ErrorIcon className="icon danger" />,
  suspended: <ErrorIcon className="icon danger" />,
};

const BillingNotification = ({ type = "info", title, message, onClose }) => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className={`billing-notification ${type}`}>
      <div className="notification-icon">{icons[type]}</div>
      <div className="notification-text">
        <p className="notification-title">{title}</p>
        <p
          className="notification-message"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
      <button
        className="notification-close"
        onClick={() => {
            setVisible(false);
            if (onClose) onClose();
        }}
      >
        <CloseIcon style={{ fontSize: 18 }} />
      </button>
    </div>
  );
};

export default BillingNotification;
